import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import axios from 'axios';
import { toast } from 'react-toastify';

export const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ phone: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post('/api/auth/login', form);
      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        toast.success('Login berhasil!');
        
        if (response.data.user.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/dashboard');
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Login gagal!');
    }
    setLoading(false);
  };

  return (
    <Layout title="🔐 Login" subtitle="Masuk ke akun OJESI" showBack>
      <div className="tg-card">
        <form onSubmit={handleSubmit}>
          <div className="tg-input-group">
            <label>Nomor HP</label>
            <input 
              className="tg-input" 
              placeholder="081234567890" 
              value={form.phone}
              onChange={(e) => setForm({...form, phone: e.target.value})}
              required
            />
          </div>
          <div className="tg-input-group">
            <label>Password</label>
            <input 
              className="tg-input" 
              type="password" 
              placeholder="Masukkan password" 
              value={form.password}
              onChange={(e) => setForm({...form, password: e.target.value})}
              required
            />
          </div>
          <button type="submit" className="tg-btn tg-btn-primary" disabled={loading}>
            {loading ? 'Loading...' : 'Login'}
          </button>
        </form>
        <div style={{ textAlign: 'center', marginTop: '16px', fontSize: '14px', color: 'var(--tg-gray)' }}>
          Belum punya akun? <Link to="/register" className="tg-link">Daftar di sini</Link>
        </div>
      </div>
    </Layout>
  );
};
